module.exports = __webpack_public_path__ + "img/Annotated_Astral_Realm_Map.8280243a.png";